function getDeleteMessage(objectType: string, objectName: string) {
    return interpolate(
        gettext('CONFIRM_DELETE_OBJECT'),
        { object_type: objectType, object_name: objectName },
        true
    );
}

export default getDeleteMessage;
